//
//
//
//
//
//
//
//
//
//

  //    import './assets/css/common.less'
  export default {
    name: 'App',
    data() {
      return {
        baseTiltle: process.env.VUE_APP_TITLE
      }
    },
    created() {

      window.document.title = this.baseTiltle
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue